/**
 * ceska-featured.js — scroll-snap karusel(y) na homepage i výpisu.
 *
 * Inicializuje KAŽDÝ [data-carousel-track] na stránce — "Vybrané nemovitosti"
 * i "Nabídka nemovitostí" sdílí stejný mechanismus. Ovládací šipky se hledají
 * v rámci nejbližší <section> přes [data-carousel-prev] / [data-carousel-next],
 * takže víc karuselů na jedné stránce se navzájem neruší.
 *
 * Funkcionalita (per karusel):
 *   - Šipky prev/next scrollují o šířku jedné karty (.snap-item + gap).
 *   - Desktop drag-to-scroll: mousedown → mousemove → mouseup.
 *     Drag > 4 px zablokuje následný click (zabrání náhodnému otevření detailu).
 *   - Touch: nativní flick + snap (browser handling, bez JS zásahu).
 *   - Autoplay: každých 5 s posun o kartu; pauzuje při hover + drag; wraps na start.
 *
 * Žádné závislosti (jQuery/Swiper). ES6+, Babel přes Gulp → dist/scripts.js.
 */

const DRAG_THRESHOLD = 4; // px, pod tím jde o klik
const AUTOPLAY_MS    = 5000;

function initCarousel(track) {
    const scope   = track.closest('section') || document;
    const prevBtn = scope.querySelector('[data-carousel-prev]');
    const nextBtn = scope.querySelector('[data-carousel-next]');

    // ─── Helper: šířka jedné karty + gap ──────────────────────────────────
    function cardStep() {
        const card = track.querySelector('.snap-item');
        if (!card) return 480;
        const gap  = parseFloat(getComputedStyle(track).columnGap) || 20;
        return card.offsetWidth + gap;
    }

    function scrollByStep(direction) {
        track.scrollBy({ left: cardStep() * direction, behavior: 'smooth' });
    }

    // ─── Autoplay ─────────────────────────────────────────────────────────
    let autoplayTimer = null;

    function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(() => {
            const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
            if (atEnd) {
                track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                scrollByStep(1);
            }
        }, AUTOPLAY_MS);
    }

    function stopAutoplay() {
        if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    }

    // ─── Arrows ───────────────────────────────────────────────────────────
    if (prevBtn) prevBtn.addEventListener('click', () => scrollByStep(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByStep(1));

    // ─── Drag-to-scroll ───────────────────────────────────────────────────
    const state = { down: false, startX: 0, startScroll: 0, moved: false };

    track.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        e.preventDefault(); // zablokuje nativní ghost drag u obrázků / odkazů
        state.down        = true;
        state.startX      = e.clientX;
        state.startScroll = track.scrollLeft;
        state.moved       = false;
        track.classList.add('is-dragging');
        stopAutoplay();
    });

    window.addEventListener('mousemove', (e) => {
        if (!state.down) return;
        const dx = e.clientX - state.startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) state.moved = true;
        track.scrollLeft = state.startScroll - dx;
    });

    window.addEventListener('mouseup', () => {
        if (!state.down) return;
        state.down = false;
        track.classList.remove('is-dragging');
        startAutoplay();
        // moved zůstane true přes následující click (suppress); reset v dalším frame
        requestAnimationFrame(() => requestAnimationFrame(() => { state.moved = false; }));
    });

    // Zachytit click v capture fázi — zablokovat navigaci po dragu
    track.addEventListener('click', (e) => {
        if (state.moved) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, true);

    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', () => { if (!state.down) startAutoplay(); });

    startAutoplay();
}

function initAllCarousels() {
    document.querySelectorAll('[data-carousel-track]').forEach(initCarousel);
}

// Inicializace po načtení DOMu
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
} else {
    initAllCarousels();
}
